function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", null, React.createElement("sfw", null, React.createElement("slices", null), React.createElement("sliceSourceBounds", {
  height: 16384,
  width: 16389,
  x: -8165,
  y: -8160,
  bottomLeftOrigin: "true"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M58.474,25.12l-26-14c-0.296-0.159-0.652-0.159-0.948,0l-26,14c-0.486,0.262-0.668,0.868-0.406,1.354    s0.868,0.669,1.354,0.406L9,25.521V52c0,0.553,0.448,1,1,1h44c0.553,0,1-0.447,1-1V25.52l2.526,1.36    c0.15,0.082,0.312,0.12,0.473,0.12c0.356,0,0.701-0.19,0.882-0.526C59.143,25.988,58.96,25.381,58.474,25.12z M17,41h30v4H17V41z     M47,39H17v-4h30V39z M17,51v-4h30v4H17z M53,51h-4V34c0-0.553-0.447-1-1-1H16c-0.552,0-1,0.447-1,1v17h-4V24.443l21-11.308    l21,11.308V51z"
}), React.createElement("path", {
  d: "M26,21c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h12c0.553,0,1-0.448,1-1v-4c0-0.552-0.447-1-1-1H26z M27,23h4v2h-4V23z     M37,25h-4v-2h4V25z"
})));

var SvgGarage = function SvgGarage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGarage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/garage.387c4114.svg";
export { ForwardRef as ReactComponent };